import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Services = () => {
  const ne3Services = [
    "Kabelgräben im offenen Verfahren",
    "Tiefbau- und Erdarbeiten",
    "Pflaster-, Asphalt- und Oberflächenarbeiten",
    "Fugentechnik (Fugenvergussverfahren)",
    "Verlegung Leerrohre & Speedpipes",
    "FTTH-Hausanschlüsse",
    "Fräsarbeiten mit Grabenfräse",
    "Muffenmontage und LWL-Spleißarbeiten",
    "Verdichtungskontrollen (LPD / TerraTest)",
    "Digitale Baustellendokumentation (DeepUp)"
  ];

  const ne4Services = [
    "Inhouse-Verkabelung im Gebäude",
    "LWL-Spleißarbeiten",
    "Montage GF-TA",
    "Gebäudeverteilung",
    "Steigleitungsbau",
    "Kellerverkabelung (Serverraum, Steigzonen)",
    "Fassadenverlegung von Glasfaserkabeln",
    "Kabelverlegung in bestehenden Leerrohrsystemen"
  ];

  return (
    <section id="services" className="py-24 bg-slate-50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-base text-amber-500 font-semibold tracking-wide uppercase">Leistungsumfang</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Technische Expertise in NE3 & NE4
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-500 mx-auto">
            Wir decken das gesamte Spektrum des passiven Glasfaserausbaus ab.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* NE3 Card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-100"
          >
            <div className="bg-slate-900 px-8 py-6">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-bold text-white">NE3</h3>
                <SafeIcon name="Truck" className="h-8 w-8 text-amber-500" />
              </div>
              <p className="text-slate-300 mt-2">Tiefbau & Hausanschluss</p>
            </div>
            <div className="p-8">
              <ul className="space-y-4">
                {ne3Services.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <SafeIcon name="CheckCircle" className="h-6 w-6 text-amber-500 mr-3 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8 pt-6 border-t border-slate-100">
                <div className="flex items-center text-sm font-semibold text-slate-900 mb-2">
                  <SafeIcon name="Users" className="h-5 w-5 text-amber-500 mr-2" />
                  41 Mitarbeiter im Bereich NE3
                </div>
                <p className="text-sm text-slate-500">2 Bauleiter · 7 Baggerfahrer · 4 LKW-Fahrer · 28 Facharbeiter</p>
              </div>
            </div>
          </motion.div>

          {/* NE4 Card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-100"
          >
            <div className="bg-amber-500 px-8 py-6">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-bold text-slate-900">NE4</h3>
                <SafeIcon name="Settings" className="h-8 w-8 text-slate-900" />
              </div>
              <p className="text-slate-800 font-medium mt-2">Inhouse & Glasfaserinstallation</p>
            </div>
            <div className="p-8">
              <ul className="space-y-4">
                {ne4Services.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <SafeIcon name="CheckCircle" className="h-6 w-6 text-amber-500 mr-3 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8 pt-6 border-t border-slate-100">
                <div className="flex items-center text-sm font-semibold text-slate-900 mb-2">
                  <SafeIcon name="Users" className="h-5 w-5 text-amber-500 mr-2" />
                  28 Mitarbeiter im Bereich NE4
                </div>
                <p className="text-sm text-slate-500">3 Bauleiter · 25 Glasfaserinstallateure</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;